import RecoveryView from './RecoveryView';

export default RecoveryView;
